import {FileExtension, MediaLibraryFile} from '@tisa-group/models';

export class MediaLibraryFileHelper {
  static isFolder(value: Partial<MediaLibraryFile>): boolean {
    if (!value || !value.file_name) {
      return false;
    }

    return value?.file_name?.endsWith('/');
  }

  static getFileExtension(fileName: string): string {
    if (!fileName) {
      return '';
    }

    return fileName.split('.').pop()?.toLowerCase() ?? '';
  }

  static getNewPath(file: MediaLibraryFile): string {
    if (!file?.id) return '';

    const pathPrefix = file.path === '/' ? '' : file.path;

    return pathPrefix + file.file_name;
  }

  static isVideoFile(fileName: string): boolean {
    return (
      [FileExtension.avi, FileExtension.mp4, FileExtension.mpg] as string[]
    ).includes(this.getFileExtension(fileName));
  }
}
